import { useCallback } from "react";
import TagManager from "react-gtm-module";

export function useAudioAnalytics() {
  const analyticsCall = useCallback(
    (
      event: string,
      eventLabel: string,
      audioId: string,
      audioListenedTime: number,
      audioDuration: number,
      audioListenedpercentage: number,
      audioSpeed: number,
      isAutoPlay?: "yes",
    ) => {
      TagManager.dataLayer({
        dataLayer: {
          event,
          ...(eventLabel && { audio_title: eventLabel }),
          ...(audioId && { audio_id: audioId }),
          ...(audioId && { audio_current_time: audioListenedTime }),
          ...(audioDuration && { audio_duration: audioDuration }),
          ...(audioId && {
            audio_percent: audioListenedpercentage,
          }),
          ...(audioSpeed && { audio_speed: audioSpeed }),
          ...(isAutoPlay && { audio_auto_played: isAutoPlay }),
          audio_source: event === "audio_start" ? "beyondwords" : "",
        },
      });
    },
    [],
  );

  return analyticsCall;
}
